<template lang="pug">
  div.h-full.flex-col.flex.grow
    //p.text-white {{possibleSelections.length ? possibleSelections[0].transform.id : "none"}}
    //div.flex.flex-row
      pbc-button(@click='undo') Undo
      pbc-button(@click='redo') Redo
    resize-observer(@notify='resized')
    .relative.grow.bg-gray-900.overflow-hidden
      edit-renderer.flex-1.relative(v-if='!showEffects',
        ref='editRenderer',
        :size='gameSize'
        :transforms-and-source='transformsAndSource',
        :background-color='backgroundColor',
        :selections='selections',
        :indirect-selections='indirectSelections',
        :holder-data='holderData',
        :editing='true',
        :selected-layers='selectedLayers',
        :enable-panning='isAdvancedMode',
        :unselectable-transforms='blockedTemplateSelections',
        @panstart='onPanStart',
        @panend='onPanEnd',
        @zoomstart='onZoomStart',
        @zoomend='onZoomEnd',
        @drag-start='dragStart',
        @drag-end='dragEnd',
        @rotate-start='rotateStart',
        @rotate-end='rotateEnd'
        @scale-start='scaleStart',
        @scale-end='scaleEnd'
        @change-center='onChangeCenter'
        @possible-selections='onPossibleSelections'
        @save-draft='onSaveDraft'
        @first-load='$emit("first-load")'
        )

        template(#always="{nothingSelected}")
          .absolute.top-0.left-0.right-0.pointer-events-none
            .mx-auto.w-16
              button.transparent-button.pointer-events-auto(v-if='!nothingSelected && !showTemplateCustomizer',
                                        class='m-2',
                                        @click='showRemovePrompt = true')
                delete.effect(:size='24')
                p.effect Remove
          .absolute.top-0.right-0
            button.transparent-button(
              @click='$store.commit("isAdvancedMode", !isAdvancedMode)',
              class='m-1'
            )
              expand-all-outline.effect(:size='24')
              p.effect(v-if='isAdvancedMode') Less
              p.effect(v-else) More

            button.transparent-button(
              @click='onSizeCanvas'
              class='m-1'
            )
              resize.effect(:size='24')
              p.effect Size

            button.transparent-button(:disabled='!undoStack.length'
              @click='undo'
              class='m-1'
            )
              undo.effect(:size='24')
              p.effect Undo

            button.transparent-button(:disabled='!redoStack.length'
              @click='redo'
              class='m-1'
            )
              redo.effect(:size='24')
              p.effect Redo

            button.transparent-button(v-if='!nothingSelected'
              @click='onClone'
              class='m-1'
            )
              content-duplicate.effect(:size='24')
              p.effect Clone

            //button.transparent-button(v-if='isAdvancedMode && nothingSelected && cameraNotCenter',
                                      class='m-1',
                                      @click='center')
              image-filter-center-focus(:size='24')
              p Center

        template(#nothing-selected="{}")
          .absolute.top-0.bottom-0.left-0.right-0.flex.justify-center.items-center(v-if='noTransformsAdded',style='pointer-events:none')
            transition(name='slide-right')
              .bg-gray-800.p-4.mx-2.flex.flex-col.justify-center.items-center(v-if='shittyTimer')
                button.pointer-events-auto.text-lg.text-white.p-3.font-bold.text-center(@click='onTapCta') {{ctaMessage}}
                //pbc-button.p-2.self-center.pbc-primary-color(@click='$refs.toolbar.add')
                  plus-circle(:size='32')
                  div.mx-2 Add

          //apollo-query(
              v-if='noTransformsAdded'
              :query='getToysQuery',
              class=''
              :variables='{from:0, size:100,public:true}')
            template(v-slot='{ result: { loading, error, data }, isLoading }')
              .absolute.top-0.bottom-0.left-0.right-0.flex.justify-center.items-center(v-if='')
                transition(name='slide-right')
                  .bg-gray-800.p-4.mx-2.flex.flex-col.justify-center.items-center(v-if='shittyTimer')
                    h1.text-lg.text-white.p-3.font-bold.text-center Start by adding toys to your game.
                    pbc-button.p-2.self-center.pbc-primary-color(@click='$refs.toolbar.add')
                      plus-circle(:size='32')
                      div.mx-2 Add
                      .spinner.text-xl.mt-8(v-if='isLoading || loading')
                    add-transforms(
                      @add='quickAddToy',
                      :toys='(data && data.getToys) ? data.getToys.items.slice(0,2) : []',
                      :only-show-toys='true')


          //portal(to='toolbar-lefts')
            pbc-button(@click='editLayers = !editLayers')
              .m-1.text-xs {{transformsAndSource.from.name}}

        template(#selected="{transform,parentTransform,indirectTransform,indirectlySelected,updateContainerBounds,holder,childComponent,moveable,bounds,...rest}")
          //grid-transform-overlay(
            :transform='transform',
            :parent-transform='parentTransform',
            :moveable='moveable'
            :render-tools='renderTools'
            :holder='holder'
            :update-container-bounds='updateContainerBounds'
            :partutil='partutil'
            :key='transform.id'
            )

          //portal(v-if='childComponent && rest.isSelected && !indirectlySelected',to='canvasOverlay')
            get-container-bounds(:container='rest.genericParentContainer',:render-tools='renderTools')
              template(#default='{bounds}')
                rectangle(:parent-container='rest.genericParentContainer',:bounds='{x1:-1,y1:-1,x2:1,y2:1}',:render-tools='renderTools',:key='transform.id')

          portal(v-if='!indirectlySelected',to='canvasOverlay')
            overlay(:bounds='bounds',position='auto',:key='transform.id')
              template(#default='{alignment}')
                .flex.flex-col.transform.absolute.-mx-12(v-if='showTransformInfo',:class='{"-translate-y-20":alignment === "top","translate-y-2":alignment === "bottom"}')
                  transform-info(:transform='transform',
                    :show-prompt='false', 
                    :actions-only='true'
                    :partutil='partutil',
                    :is-template-component='showTemplateCustomizer'
                    @edit='viewComponents({transform})',
                    @instant-edit='onInstantEditComponent({transform,component:$event.component})',
                    @instant-add='onInstandAdd',
                    @set-duration='onInstantDuration({transform})',
                    direction='col')

                  //pbc-button.w-20.pbc-z-level-4.text-center.pbc-primary-color(v-if='!isPanning && !isDragging',
                    @click='viewComponents({transform})')
                    .mx-auto.text-gray-800
                      pencil.float-left(:size='20')
                      span.ml-2.text-black Edit
                  pbc-button.w-20.pbc-z-level-4.text-center.pbc-primary-color(v-if='!isPanning && !isDragging && isFunky(transform)',
                    @click='quickAddToy()',
                  )
                    .mx-auto.text-gray-800
                      plus-circle.float-left(:size='20')
                      span.ml-2.text-black Add

                  pbc-button.w-24.pbc-z-level-4.text-center.pbc-warning-color(v-if='!isPanning && !isDragging && isOutsideCamera(rest.worldPos)',@click='sizeCanvas = true')
                    .mx-auto.text-gray-800
                      alert.float-left(:size='20')
                      span.ml-2.text-black.text-xs Outside
                  //inline-render.ml-1(:transform='transform', :from='transformsAndSource.from', :gamedata='transformsAndSource.gamedata', :source='transformsAndSource.source', background-color='#e2e8f0')
          save-selection(:selections-data='selectionsData',
            :transform='transform',
            :indirect-transform='indirectTransform',
            :indirectly-selected='indirectlySelected',
            :child-component='childComponent',
            :update-container-bounds='updateContainerBounds',
            :parent-transform='parentTransform',
            :children-component='rest.childrenComponent',
            :key='transform.id + indirectTransform.id + indirectlySelected',
            :holder='holder')

      div.h-32(v-if='showTemplateChanger')
        portal(to='components-main-modal')
          pbc-popup(@close='currentTemplateMode = "editTemplate"')
            choose-template(:current-template-id='template.id')

      portal(v-if='editing && !showEffects && quickEdit === viewingInfoTransform.id',to='component-edit-modal-after')
        edit-overlay(@post='$emit("next")'
                    :component='quickEditComponent'
                    :transform='viewingInfoTransform'
                    :transforms-and-source='transformsAndSource'
                    :render-tools='renderTools'
                    :partutil='partutil'
                    :selections-data='selectionsData'
                    :selected-layers='selectedLayers',
                    :layers='transformsAndSource.from.layers'
                    @close='onCloseEditOverlay'
                    @done='onDoneEditOverlay'
                    :holder-data='holderData')

      set-duration(v-if='editing && showEffects',
                   class='grow'
                   @back="onBackFromAnimator"
                   @post='$emit("post")'
                   :transform='animateTransform'
                   :transforms-and-source='transformsAndSource'
                   :partutil='partutil'
                   :selections-data='selectionsData'
                   :holder-data='holderData')

      portal-target(name='above-renderer')

      //div.h-32.fex.flex-col.absolute.right-0.left-0.pbc-z-level-1(v-if='showTemplateCustomizer',:class='templateCustomizerVerticalPosition')
        //.flex-none.h-8.pl-4(@click='onClickChangeTemplate')
          button.outline-button.h-8.p-2.flex-none.flex.flex-row
            pencil-box
            .text-lg.text-gray-300.py-1.pl-1 {{template.title}}
      template-customizer.h-20.w-full.bg-blue-900.border-2.border-black.rounded.shadow.p-1.border-box.pointer-events-auto(v-if='showTemplateCustomizer',
        ref='templateCustomizer',
        :template='template',
        :partutil='partutil'
        :viewing-transform='viewingInfoTransform'
        :disable-post-button='noTransformsAdded'
        :transforms-and-source='transformsAndSource'
        :render-tools='renderTools'
        :selections-data='selectionsData'
        :holder-data='holderData'

        @edit='onTemplateComponentEdit'
        @view='onTemplateComponentView'
        @post='onNext',
        @updated-component='onTemplateComponentUpdated'
        @keyboard-open='onTemplateComponentFocused'
        @keyboard-close='onTemplateComponentBlur'

        @change='onTemplateChangeComponent'
        )

      awesome-bar.w-full.relative.pointer-events-none(v-if='showAwesomeBar',
        :partutil='partutil'
        :render-tools='renderTools'
        :transforms-and-source='transformsAndSource'
        :holder-data='holderData'
        :no-transforms-added='noTransformsAdded'
        :selected-layers='selectedLayers',
        :layers='transformsAndSource.from.layers'
        :enable-template-button='hasTemplate'
        :next-is-post='nextIsPost'
        @effects='showEffects = true'
        @add-children='addChildren'
        @select-children='selectChildren'
        @show-set-duration='onShowSetDuration'
        @clear-layer='onClearLayer'
        @next='onNext'
        @post='onPost'
        @change='onAwesomeBarChange'
        @remove-draft='$emit("remove-draft")'
        @toggle-template-mode='onToggleTemplateMode'
        @animate='onShowAnimate'
        )

      .bg-gray-900.w-full.flex.flex-row.justify-center.absolute.bottom-0.pbc-z-level-2(v-show='showToolbar && isAdvancedMode && !isDragging && !isPanning')
        transform-details.w-full(v-if='isAdvancedMode && !editingComponents && viewingInfoTransform.id',
          class='md:self-center',
          :transform='viewingInfoTransform'
          :transforms-and-source='transformsAndSource'
          :partutil='partutil',
          :holder-data='holderData',
          :selections-data='selectionsData'
          @view-components='viewComponents',
          @edit='onEditTransformComponent',
          @instant-edit='onInstantEditComponent',
          @instant-add='onInstandAdd',
          @center='center'
          @change="update(viewingInfoTransform, $event)",
          :key='viewingInfoTransform.id'
          @add-component='startAddComponents'
          @close='onDeselectAll'
          @preview='play'
          @change-components='onChangeComponents'
          @edit-components-fullscreen='onEditComponentsFullscreen'
          )

        instant-add-pack.h-32(v-if='isAdvancedMode',ref='instantChoosePack',v-show='!viewingInfoTransform.id && isMounted',
          :partutil='partutil',
          :render-tools='renderTools',
          :selected-layers='selectedLayers',
          :layers='transformsAndSource.from.layers'
          :holder-data='holderData'
          direction='horizontal'
          @mode='onInstantMode',
          @add-children='addChildren'
          @transform-update='queueTransformUpdate',
          @select-children='selectChildren',
          @clear-layer='onClearLayer'
          )


    div(v-if='editingComponents')
      .flex-col.grow
        transform-edit-components(ref='transformEditComponents',
          :transform='viewComponentsForTransform',
          @close='editingComponents = false',
          :partutil='partutil',
          :transforms-and-source='transformsAndSource',
          :selections-data='selectionsData',
          :initial-edit-component='quickEditComponent',
          @change-editing-component='changeEditingComponent'
          @change='updateComponent'
          @add='startAddComponents'
          @remove='removeComponents'
          @add-recommendation='onAddRecommendation'
          @add-link-recommendation='addLinkRecommendation'
          @undo='undo',
          @redo='redo',
          :has-undos='!!undoStack.length',
          :has-redos='!!redoStack.length',
          @preview='play'
          )
    div.bg-gray-800.flex.flex-col.flex-none(v-if='isAdvancedMode')
      apollo-query(v-show='!editingComponents && !viewingInfoTransform.id',
                   :query='listPacksQuery',
                   class='flex flex-row justify-center'
                   fetch-policy='cache-and-network'
                   @result='onInitialLoadPacks'
                   :variables='{nextToken:"", size:100}')
        template(v-slot='{ result: { loading, error, data }, isLoading }')
          div(v-if='data && data.getPacks && data.getPacks.items',
            v-for='layer in getLayersFromPacks(((data||{}).getPacks||{}).items || [])',
              :key='layer.name'
              )
            pbc-toggle-button(v-model='selectedLayers[layer.id]',
                              @toggle='onToggleLayer(layer, $event)',
                              :disable-toggle='selectedLayers[layer.id]') {{layer.name}}

          
      edit-toolbar-anon(v-if='isAnonymous && showToolbar'
        class='md:self-center'
        :selections-data='selectionsData',
        :no-transforms-added='noTransformsAdded',
        :editing-component='editingComponent',
        :disable-preview='noTransformsAdded'
        :cta-message='ctaMessage'
        :camera-not-center='cameraNotCenter'
        @play='play'
        @zoomIn='zoomIn',
        @zoomOut='zoomOut'
        @center='center'
        @layers='editLayers = !editLayers'
        @remove="remove",
        @background='onSetBackground'
        @foreground='onSetForeground'
        @post='$emit("post")'
        )
      edit-toolbar.bg-gray-800(v-else-if='showToolbar',
        ref='toolbar',
        class='md:self-center'
        :selections-data='selectionsData',
        :root='transformsAndSource.root',
        :editing-component='editingComponent',
        :undo-length='undoStack.length',
        :redo-length='redoStack.length',
        :primary='!hasSelections ? "add" : ""',
        :no-transforms-added='noTransformsAdded',
        :disable-preview='noTransformsAdded'
        @add-transforms="startAddTransforms"
        @remove="remove",
        @clone="clone",
        @instance="instance",
        @undo="undo",
        @redo="redo",
        @play='play'
        @zoomIn='zoomIn',
        @zoomOut='zoomOut',
        @layers='editLayers = !editLayers'
        @settings='editSettings = !editSettings'
        )
        //template(#left='{}')
          portal-target.flex(name='toolbar-lefts', multiple)
      //div.overflow-scroll.h-32
        div.overflow-scroll
          div ID
            span(v-for='t in Object.keys(indirectSelections)')
              | {{t}} {{indirectSelections[t]}}
              | --
          div D
            span(v-for='t in Object.keys(selections)')
              | {{t}} {{selections[t]}}
        div(v-for='s in Object.values(selectionsData)')
          span {{s.transform.id}} / {{s.indirectlySelected}}

      //p.text-white {{undoStack.length}} / {{redoStack.length}}

    .pbc-z-level-2
      simple-or-advanced-add-transforms(v-if='showSimpleAdd',
        v-show='!hideSimpleAddForPlacing'
        :partutil='partutil'
        :render-tools='renderTools'
        @hide-for-placing='hideSimpleAddForPlacing = true'
        @close='showSimpleAdd = false'
        @mode='onInstantMode',
        @add-children='addChildren'
        @transform-update='queueTransformUpdate',
        @select-children='selectChildren',
        @advanced-mode='onAddAdvancedMode'
        )


    .pbc-z-level-3
      portal-target(name='components-main-modal')
      portal-target(name='component-edit-modal')
      add-transform-wizard-dialog(
        v-if='addingToParents.length',
        :adding-to-parents='addingToParents',
        :adding-to-children-components='addingToChildrenComponents',
        :partutil='partutil',
        :transforms-and-source='transformsAndSource',
        :skip-funky='true',
        @close='closeAddTransformWizard',
        @done='closeAddTransformWizard',
        @add-children='addChildren'
        @select-children='selectChildren'
        @position-children='positionChildren'
      )
      add-component-wizard-dialog(
        v-if='addingToComponents.length',
        :adding-to-parents='addingToComponents',
        :adding-to-transforms='addingToComponentsTransforms',
        :partutil='partutil',
        :transforms-and-source='transformsAndSource',
        :components='transformsAndSource.from.components',
        :links='transformsAndSource.from.links',
        :autolink='autoLinkRecommendation',
        @close='closeAddComponentWizard',
        @done='closeAddComponentWizard',
        @preview='play',
        @add-components='addComponents'
        @add-link-recommendation='addLinkRecommendation'
      )
      settings-dialog(v-if='editSettings',
                      @close='editSettings = false',
                      :gamedata='gamedata')
      layers-edit-dialog(v-if='editLayers',
                         :partutil='partutil',
                         :transforms-and-source='transformsAndSource',
                         :selections='selections',
                         :indirect-selections='indirectSelections',
                         @selections='onPossibleSelections'
                         @change='updateLayer'
                         @close='editLayers = false')

    .pbc-z-level-3
      pbc-popup(v-if='sizeCanvas',@close='sizeCanvas = false')
        canvas-sizer.h-64(:gamedata='gamedata',
                     :render-tools='renderTools',
                     :size='gameSize'
                     )

      portal-target(name='component-edit-modal-after')
    pbc-confirmation(v-if='showRemovePrompt',
                     @ok='onRemove',
                     @cancel='showRemovePrompt = false')
      h3.text-gray-700 Do you want to remove?

    //history(name='undorenderer--selection', v-model='historySelectionsData')
    //history(name='undorenderer--add-transforms', v-model='historyAddTransformsData')
    //history(name='undorenderer--add-components', v-model='historyAddComponentsData')
    //history(name='undorenderer--view-components', v-model='historyEditingComponents')


    //pbc-modal(v-if='addingToComponent',title='Add New',@close='closeAddComponentWizard',@done='closeAddComponentWizard')
      template(#default='')
        add-component-wizard(
          :component='addingToComponent',
          :partutil='partutil',
          @close='closeAddComponentWizard',
          @done='closeAddComponentWizard',
          @add-component-with-link='addComponentWithLink'
        )
</template>
<script>

import Resize from '@icons/Resize.vue';
import PencilBox from '@icons/PencilBox.vue';
import Undo from '@icons/Undo.vue';
import Redo from '@icons/Redo.vue';
import { mapState } from 'vuex';
import Delete from '@icons/Delete.vue';
import ExpandAllOutline from '@icons/ExpandAllOutline.vue';
import PbcToggleButton from '@ui/atoms/PbcToggleButton.vue';
import { ApolloQuery } from 'vue-apollo';
import { listPacksQuery } from '@/gql/Queries.js';
import TransformInfo from '@ui/molecules/TransformInfo.vue';
import * as ComponentsDb from '@/edit/tree/componentsdb.js';
import InstantAddPack from '@ui/organisms/InstantAddPack.vue';
import SelectIcon from '@icons/Select.vue';
import Information from '@icons/Information.vue';
import ContentDuplicate from '@icons/ContentDuplicate.vue';
import SettingsDialog from '@ui/molecules/SettingsDialog.vue';
import LayersEditDialog from '@ui/organisms/LayersEditDialog.vue';
import PbcConfirmation from '@ui/molecules/PbcConfirmation.vue';
import { findDbEntry } from '@/edit/tree/componentsdb.js';
import PlusCircle from '@icons/PlusCircle.vue';
import Rectangle from '@edit/atoms/Rectangle.vue';
import FreezedContainer from '@edit/render/freezedcontainer.js';
import GetContainerBounds from '@edit/atoms/GetContainerBounds.vue';
import { isEqualWith, zip, toPairs, fromPairs, orderBy, uniqBy, flatten, cloneDeep, debounce } from 'lodash';
import Overlay from '@edit/atoms/Overlay.vue';
import ArrowUpThick from '@icons/ArrowUpThick.vue';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
import Pencil from '@icons/Pencil.vue';
import Minus from '@icons/Minus.vue';
import Plus from '@icons/Plus.vue';
import Alert from '@icons/Alert.vue';
import MagnifyMinus from '@icons/MagnifyMinus.vue';
import MagnifyPlus from '@icons/MagnifyPlus.vue';
import ImageFilterCenterFocus from '@icons/ImageFilterCenterFocus.vue';
import SimpleOrAdvancedAddTransforms from '@ui/organisms/SimpleOrAdvancedAddTransforms.vue';
import InlineRender from '@edit/atoms/InlineRender.vue';
import TransformEditComponents from '@edit/molecules/TransformEditComponents.vue';
import SaveSelection from '@edit/atoms/SaveSelection.vue';
import EditRenderer from '@edit/molecules/EditRenderer.vue';
import TransformDetails from '@ui/molecules/TransformDetails.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import EditToolbar from '@ui/molecules/EditToolbar.vue';
import EditToolbarAnon from '@ui/molecules/EditToolbarAnon.vue';
import Partutil from '@edit/tree/partutil.js';
import Treeutil from '@edit/tree/treeutil.js';
import AddTransformWizardDialog from '@ui/organisms/AddTransformWizardDialog.vue';
import AddComponentWizardDialog from '@ui/organisms/AddComponentWizardDialog.vue';
import AddTransforms from '@ui/organisms/AddTransforms.vue';
import gql from 'graphql-tag';
import AwesomeBar from '@ui/organisms/AwesomeBar.vue';
import SetDuration from '@ui/organisms/SetDuration.vue';
import TemplateCustomizer from '@ui/organisms/TemplateCustomizer.vue';
import ChooseTemplate from '@ui/molecules/ChooseTemplate.vue';
import EditOverlay from '@ui/organisms/EditOverlay.vue';
import CanvasSizer from '@ui/atoms/CanvasSizer.vue';

const getToysQuery = gql(`
  query getToys($from: Int!, $size: Int!, $public: Boolean) {
    getToys(from: $from, size: $size, public: $public) {
      items {
        id,
        name,
        description,
        thumbnailImage,
        toy
      }
    }
  }
`);

import GridTransformOverlay from '@/ui/molecules/GridTransformOverlay.vue';


export default {
  props:{
    transformsAndSource:{
      type:Object,
      required:true
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    },
    editing:{
      type:Boolean,
      default:true
    },
    template:{
      type:Object,
      default() {
        return {};
      }
    }
  },
  data() {
    const partutil = new Partutil(this.transformsAndSource);
    const undoHandlers = {
      'drag':this.undoDrag.bind(this),
      'rotate':this.undoRotate.bind(this),
      'scale':this.undoScale.bind(this),
      'transformUpdate':this.undoTransformUpdate.bind(this),
      'addChild':this.undoAddChild.bind(this),
      'addComponents':this.undoAddComponents.bind(this),
      'removeComponents':this.undoRemoveComponents.bind(this),
      'removeChild':this.undoRemoveChild.bind(this),
      'duplicate':this.undoDuplicate.bind(this),
      'instanceTransform':this.undoInstanceTransform.bind(this),
      'updateComponent':this.undoUpdateComponent.bind(this),
      'setCanvasSize':this.undoSetCanvasSize.bind(this)
    }
    const redoHandlers = {
      'drag':this.redoDrag.bind(this),
      'rotate':this.redoRotate.bind(this),
      'scale':this.redoScale.bind(this),
      'transformUpdate':this.redoTransformUpdate.bind(this),
      'addChild':this.redoAddChild.bind(this),
      'addComponents':this.redoAddComponents.bind(this),
      'removeComponents':this.redoRemoveComponents.bind(this),
      'removeChild':this.redoRemoveChild.bind(this),
      'duplicate':this.redoDuplicate.bind(this),
      'instanceTransform':this.redoInstanceTransform.bind(this),
      'updateComponent':this.redoUpdateComponent.bind(this),
      'setCanvasSize':this.redoSetCanvasSize.bind(this)
    }

    const holderData = {};
    this.$store.commit('setHolderData', holderData);

    const selectionsData = [];
    this.$store.commit('setSelectionsData', selectionsData);

    return {
      undoStack: [],
      redoStack: [],
      undoHandlers,
      redoHandlers,
      selections: {},
      indirectSelections: {},
      selectionsData,
      selectionsById: {},
      queuedTransformUpdates: {},
      queuedSceneObjectUpdates: {},
      editingComponents:false,
      viewComponentsForTransform:null,
      addingToParents:[],
      addingToChildrenComponents:[],
      addingToComponents: [],
      addingToComponentsTransforms: [],
      editingComponent: null,
      isPanning:false,
      isDragging:false,
      resized:debounce(this._resized, 50),
      holderData,
      autoLinkRecommendation:undefined,
      quickEditComponent:undefined,
      shittyTimer: false,
      getToysQuery,
      editRendererCenter:{
        x: 0,
        y: 0
      },
      viewingInfoTransform:{},
      possibleSelections:[],
      editLayers:false,
      isMounted:false,
      instantMode:'',
      showSimpleAdd: false,
      hideSimpleAddForPlacing: false,
      partutil,
      currentLayer:'foreground',
      selectedLayers:{default:true},
      listPacksQuery,
      layers:{
        default:{
          id:'default',
          name:'Foreground',
          zindex:1
        }
      },
      showEffects: false,
      showRemovePrompt: false,
      quickEdit: '',
      currentTemplateMode:"editTemplate",
      isLastTemplateComponent: false,
      enableTemplateJumpingFeature:false,
      selectedTransformWorldPos:{x:0,y:0},
      animateTransform:{},
      editSettings: false,
      sizeCanvas: false,
      sizeCanvasPreviousSize:{}
    }
  },
  mounted() {
    this.lolVisualHeight = window.innerHeight;
    if (typeof(window.visualViewport) !== 'undefined') {
      this.lolVisualHeight = window.visualViewport.height;
    }

    if (this.$vhcheck) {
      this.$vhcheck.on('update', this.resized);
    }
    window.addEventListener('resize', this.resized);
    setTimeout( () => {
      this.shittyTimer = true;
    }, 1300);

    this.calculateNoTransformsAdded();
    this.isMounted = true;

    if (this.transformsAndSource.gamedata.gamedata.__autoRemixImage) {
      this.autoRemixImage(this.transformsAndSource.gamedata.gamedata);
      delete this.transformsAndSource.gamedata.gamedata.__autoRemixImage;
      this.calculateNoTransformsAdded();
      this.selectFirstTransform();
    }
    if (this.transformsAndSource.gamedata.gamedata.__autoRemixData) {
      this.autoRemixData(this.transformsAndSource.gamedata.gamedata);
      delete this.transformsAndSource.gamedata.gamedata.__autoRemixData;
      this.calculateNoTransformsAdded();
      this.selectFirstTransform();
    }

    if (!this.hasTemplate && this.transformsAndSource.gamedata.gamedata.__autoSelectFirstTransform) {
      delete this.transformsAndSource.gamedata.gamedata.__autoSelectFirstTransform;
      this.selectFirstTransform();
    }

    if (this.hasTemplate) {
      console.log('9999999999999999999');
      this.$store.commit('setTemplateMode', true);
    } else {
      console.log('888888888888888888');
      this.$store.commit('setTemplateMode', false);
    }

    const game = this.transformsAndSource.gamedata.gamedata.game;
    if (game.timelimit === -1) {
      this.$store.commit('setAnimationEnabled', false);
    } else {
      this.$store.commit('setAnimationEnabled', true);
    }

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resized);
    if (this.$vhcheck) {
      this.$vhcheck.removeListener('update', this.resized);
    }
  },
  methods: {
    onSizeCanvas() {
      this.sizeCanvas = true;
    },
    onCloseEditOverlay() {
      this.viewComponentsForTransform = null;
      this.quickEditComponent = null;
      this.quickEdit = '';
    },
    onDoneEditOverlay({nv,ov}) {
      const transform = this.viewComponentsForTransform;
      this.addToUndo({
        type:'updateComponent',
        data:{
          nv,
          ov,
          transform
        }
      });
      this.onCloseEditOverlay();
    },
    onClone() {
      const transformsToClone = this.selectionsData.filter( (sd) => { return !sd.indirectlySelected } )
                                         .map( ( {parentTransform, transform} ) => {
                                           return {
                                             parent:parentTransform,
                                             child: transform
                                           }
                                         });
      this.clone({transformsToClone});
    },
    onBackFromAnimator() {
      this.showEffects = false;
      this.animateTransform = {};
    },
    onTemplateComponentFocused() {
      this.__templateInputFocused = true;
    },
    onTemplateComponentBlur() {
      this.__templateInputFocused = false;
      if (this.enableTemplateJumpingFeature) {
        this.delayedCenter(null, true);
      }
    },
    onTapCta() {
      if (this.hasTemplate) {
        this.currentTemplateMode = "editTemplate";
        this.$store.commit('setTemplateMode', true);
      }
    },
    onTemplateComponentUpdated() {
      this.calculateNoTransformsAdded();
      if (this.__debChangeTextTimeout) {
        clearTimeout(this.__debChangeTextTimeout);
      }
      this.__debChangeTextTimeout = setTimeout( () => {
        this.$ana.track({
          eventCategory:'template',
          eventAction:'changeText'
        });
      }, 800);
    },
    onClickChangeTemplate() {
      this.currentTemplateMode = 'chooseTemplate'
    },
    isSelectableLayer(layer) {
      return layer !== "background" && layer !== "meme_template";
    },
    onTemplateComponentEdit({component,transform}) {
      console.log('on template component edit', component, transform);
      this.onInstantEditComponent({component,transform});
      this.queueTransformSelection(transform);
    },
    onTemplateComponentView({component,transform,isLast}) {
      this.isLastTemplateComponent = isLast;
      if (this.editingComponents && this.quickEditComponent) {
        clearTimeout(this.__templateComponentViewTimeout);
        return;
      }
      if (this.__templateComponentViewTimeout) {
        clearTimeout(this.__templateComponentViewTimeout);
      }
      this.__templateComponentViewTimeout = setTimeout( () => {
        this.clearSelections();
        this.queueTransformSelection(transform);

        if (this.enableTemplateJumpingFeature) {
          if (this.__templateInputFocused) {
            this.delayedCenter({x:0,y:4});
          } else {
            this.delayedCenter();
          }
        } else {
          this.renderTools.addToRunBatch( () => {
          this.renderTools.addToRunBatch( () => {
          this.renderTools.addToRunBatch( () => {
            this.selectedTransformWorldPos = this.getSelectedWorldPos();
          });
          });
          });
        }
      }, 250);
    },
    delayedCenter(offset, skipSelection) {
      this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          this.renderTools.addToRunBatch( () => {
            this.center(offset, skipSelection);
          });
        });
      });
    },
    onToggleTemplateMode() {
      this.currentTemplateMode = "chooseTemplate";
      this.$store.commit('setTemplateMode', true);
    },
    onSelectTopMode(mode) {
      if (mode === "animate") {
        this.showEffects = true;
      } else if (mode === "placement") {
        this.showEffects = false;
      }
    },
    onPost() {
      if (this.isAnimationEnabled) {
        this.showEffects = true;
      } else {
        this.$emit("next");
      }
    },
    onNext() {
      //this.$emit('next');
      if (!this.isLastTemplateComponent && this.showTemplateCustomizer) {
        this.$refs.templateCustomizer.gotoNextTemplateItem();
      } else {
        if (this.nextIsPost) {
          this.$emit("next");
        } else {
          this.showEffects = true;
        }
      }
    },
    onEditComponentsFullscreen() {
      this.onEditTransformComponent(this.viewingInfoTransform);
    },
    onSaveDraft() {
      this.$emit('add-undo');
    },
    onAwesomeBarChange() {
      this.$emit("add-undo");
      this.calculateNoTransformsAdded();
    },
    onRemove() {
      this.showRemovePrompt = false;
      const activeSelections = this.selectionsData.filter( (sd) => {
        return !sd.indirectlySelected;
      });

      const transformsToRemove = activeSelections.map( ({parentTransform, transform}) => {
        return {
          parent: parentTransform,
          child: transform
        }
      });

      this.remove({transformsToRemove});
    },
    selectNextPossibleSelection() {
      const currentSelection = this.possibleSelections.findIndex( ({transform:{id}}) => {
        return id === this.viewingInfoTransform.id;
      });
      const prevSelection = this.possibleSelections[currentSelection];
      //this.togglePossibleSelection(this.possibleSelections[currentSelection]);

      const len = this.possibleSelections.length;
      const newSelection = this.possibleSelections[(currentSelection + 1) % len]
      this.togglePossibleSelection(newSelection);

      if (prevSelection && newSelection) {
        this.possibleSelections = [];
        if (prevSelection.transform && newSelection.transform && prevSelection.transform.id === newSelection.transform.id) {
          if (this.templateMode) {
            const component = this.partutil.findComponentForTransform(prevSelection.transform);

            if (component.type === 'text' && component.text === '') {
              const transform = prevSelection.transform;
              this.onTemplateComponentEdit({component,transform});
              return;
            }
          }
          setTimeout( () => {
            this.$refs.editRenderer.deselectAll(true);
            this.possibleSelections = [];
            this.onDeselectAll();
          }, 60);
        }
      }
    },
    onToggleLayer(layer, value) {
      this.clearSelections();
      this.onDeselect();
      this.$refs.instantChoosePack.reset();
      if (value) {
        Object.keys(this.selectedLayers).forEach( (id) => {
          if (id !== layer.id) {
            this.$set(this.selectedLayers, id, false);
          }
        });
        this.$ana.track({
          eventCategory:'ui',
          eventAction:'chooseLayer',
          extra:{layer:layer.id}
        });
      } else {
        //this.$set(this.selectedLayers, layer.name, true);
      }

    },
    onInitialLoadPacks({error,data}) {
      if (typeof(data) === 'undefined') {
        return [];
      }
      const layers = this.getLayersFromPacks(data.getPacks.items);
      this.layers = {};
      layers.forEach( (layer) => {
        const id = layer.id;
        this.layers[id] = layer;
        this.$set(this.selectedLayers, id, false);
      });

      this.$set(this.selectedLayers, 'default', true);

    },
    toggleSimpleAdd({parents,childrenComponents}) {
      this.hideSimpleAddForPlacing = false;
      this.showSimpleAdd = true;
      this.__tmpParents = parents;
      this.__tmpChildrenComponents = childrenComponents;
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'addButton'
      });

    },
    onEditTransformComponent(transform) {
      this.editingComponents = !this.editingComponents;
      this.viewComponentsForTransform = transform;
      this.quickEditComponent = null;
    },
    onInstantEditComponent({component,transform}) {
      if (true || component.type !== 'text') {
        this.viewComponentsForTransform = transform;
        this.quickEditComponent = component;
        this.quickEdit = transform.id;
      } else {
        this.editingComponents = true;
        this.viewComponentsForTransform = transform;
        this.quickEditComponent = component;
      }
    },
    viewComponents({transform}) {
      this.editingComponents = !this.editingComponents;
      this.viewComponentsForTransform = transform;
      this.quickEditComponent = null;
    },
    viewInfo({transform}) {
      this.viewingInfoTransform = transform || {};
    },
    startAddTransforms({parents,childrenComponents}) {
      this.addingToParents = parents;
      this.addingToChildrenComponents = childrenComponents || [];
    },
    startAddComponents({parents,transforms}) {
      this.autoLinkRecommendation = undefined;
      this.addingToComponents = parents;
      this.addingToComponentsTransforms = transforms;
    },
    instance({transformsToClone}) {
      this.clearSelections();

      this.renderTools.addToRunBatch( () => {
        const {addedParents, addedChildren} = this.partutil.duplicateAndLinkChildren(transformsToClone);

        this.addToUndo({
          type:'instanceTransform',
          data:{
            addedParents,
            addedChildren
          }
        });

        this.queueTransformSelections(addedChildren);
      });
    },
    clone({transformsToClone}) {
      this.clearSelections();

      this.renderTools.addToRunBatch( () => {
        const {addedChildren, addedParents, addedComponents, addedLinks} = this.partutil.duplicateChildren(transformsToClone);

        this.addToUndo({
          type:'duplicate',
          data:{
            addedChildren,
            addedParents,
            addedComponents,
            addedLinks
          }
        });

        this.queueTransformSelections(addedChildren);

        
      });
    },
    remove({transformsToRemove}) {
      this.clearSelections();

      this.renderTools.addToRunBatch( () => {
        const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(transformsToRemove);
        this.addToUndo({
          type:'removeChild',
          data:{
            removedChildren,
            removedComponents,
            removedLinks,
            removedParents
          }
        });
      });

      this.onDeselect();

    },
    updateComponent({transform, nv, ov}) {
      this.addToUndo({
        type:'updateComponent',
        data:{
          nv,
          ov,
          transform
        }
      });
      this.queueSceneObjectUpdate(transform);
    },
    update(transform, {type, nv, ov}) {
      const transformId = transform.id;

      this.onTransformUpdate({transform, transformId, type, nv, ov});

      this.queueTransformSelection(transform);

    },
    undo() {
      if (!this.undoStack.length) {
        return;
      }
      const {type,data} = this.undoStack.pop();
      const clonedData = cloneDeep(data);
      const skipAddRedo = this.undoHandlers[type](data);
      if (!skipAddRedo) {
        this.redoStack.push({
          type,
          data:clonedData
        });
      }

      this.$ana.track({
        eventCategory:'undoredo',
        eventAction:'undo',
        extra:{
          type
        }
      });
    },
    redo() {
      if (!this.redoStack.length) {
        return;
      }
      const {type,data} = this.redoStack.pop();
      const skippAddUndo = this.redoHandlers[type](data);
      if (!skippAddUndo) {
        this.addToUndo({
          type,
          data
        }, false);
      }
      this.$ana.track({
        eventCategory:'undoredo',
        eventAction:'redo',
        extra:{
          type
        }
      });
    },
    dragStart({data}) {
      this.busyDraggingData = data;
      this.isDragging = true;
    },
    dragEnd({data}) {
      this.isDragging = false;
      if (this.busyDraggingData) {
        this.addToUndo({
          type:'drag',
          data:{
            befores:this.busyDraggingData,
            afters:data
          }
        });
      }
    },
    rotateStart({data}) {
      this.isDragging = true;
      this.busyRotatingData = data;
    },
    rotateEnd({totalRotationDelta,data}) {
      this.isDragging = false;
      this.addToUndo({
        type:'rotate',
        data:{
          befores:this.busyRotatingData,
          afters:data
        }
      });
    },
    scaleStart({data}) {
      this.isDragging = true;
      this.busyScalingData = data;
    },
    scaleEnd({data}) {
      this.isDragging = false;
      this.isDragging = false;
      if (this.busyScalingData) {
        this.addToUndo({
          type:'scale',
          data:{
            befores:this.busyScalingData,
            afters:data
          }
        });
      }
    },
    undoRotate({befores,afters}) {
      this.clearSelections();

      const renderTools = this.$refs.editRenderer.$refs.renderer.renderTools;
      const transforms = this.transformsAndSource.gamedata.findAllTransforms();
      for (let i = 0; i < befores.length; i++) {
        const {id,rotation,indirectlySelected,updateContainerBounds} = befores[i];

        this.renderTools.addToRunBatch( () => {
          // TODO: this is very slow
          for (let j = 0; j < transforms.length; j++) {
            const transform = transforms[j];
            if (transform.id === id) {
              transform.transform.rotation = rotation;
              this.queueTransformSelection(transform);
            }
          }
        });
      }
    },
    redoRotate({befores,afters}) {
      this.undoRotate({befores:afters});
    },
    undoScale({befores,afters}) {
      this.clearSelections();

      const renderTools = this.$refs.editRenderer.$refs.renderer.renderTools;
      const transforms = this.transformsAndSource.gamedata.findAllTransforms();
      for (let i = 0; i < befores.length; i++) {
        const {id,scale,localScale,indirectlySelected,updateContainerBounds} = befores[i];

        this.renderTools.addToRunBatch( () => {
          // TODO: this is very slow
          for (let j = 0; j < transforms.length; j++) {
            const transform = transforms[j];
            if (transform.id === id) {
              transform.transform.scale.x = scale.x;
              transform.transform.scale.y = scale.y;
              transform.transform.localScale.x = localScale.x;
              transform.transform.localScale.y = localScale.y;
              this.queueTransformSelection(transform);
            }
          }
        });
      }
    },
    redoScale({befores,afters}) {
      this.undoScale({befores:afters});
    },
    undoDrag({befores,afters}) {
      this.clearSelections();

      const renderTools = this.$refs.editRenderer.$refs.renderer.renderTools;
      const transforms = this.transformsAndSource.gamedata.findAllTransforms();
      for (let i = 0; i < befores.length; i++) {
        const {id,x,y,indirectlySelected} = befores[i];

        const transform = this.transformsAndSource.gamedata.getTransformById(id);
        this.queueTransformSelection(transform);

        this.renderTools.addToRunBatch( () => {
          // TODO: this is very slow
          for (let j = 0; j < transforms.length; j++) {
            const transform = transforms[j];
            if (transform.id === id) {
              transform.transform.pos.x = x;
              transform.transform.pos.y = y;

              this.queueTransformUpdate(transform);
            }
          }
        });
      }
    },
    redoDrag({befores,afters}) {
      this.undoDrag({befores:afters});
    },
    undoTransformUpdate({transformId, type, nv, ov}) {
      const transform = this.transformsAndSource.gamedata.getTransformById(transformId);
      this.clearSelections();

      if (type === "position") {
        this.$set(transform.transform.pos, 'x', ov.x);
        this.$set(transform.transform.pos, 'y', ov.y);
      } else if (type === "scale") {
        this.$set(transform.transform.scale, 'x', ov.x);
        this.$set(transform.transform.scale, 'y', ov.y);
      } else if (type === "localScale") {
        this.$set(transform.transform.localScale, 'x', ov.x);
        this.$set(transform.transform.localScale, 'y', ov.y);
      } else if (type === "rotation") {
        this.$set(transform.transform, 'rotation', ov);
      } else if (type === "localRotation") {
        this.$set(transform.transform, 'localRotation', ov);
      } else if (type === "zindex") {
        this.$set(transform.transform, 'zIndex', ov);
      } else if (type === "alpha") {
        this.$set(transform.transform, 'alpha', ov);
      } else if (type === "anchor") {
        this.$set(transform.transform.anchor, 'x', ov.x);
        this.$set(transform.transform.anchor, 'y', ov.y);
      } else if (type === "vars") {
        this.$set(transform.vars, Object.assign(transform.vars,ov));
      } else if (type === "sendToOrigin") {
        this.$set(transform.transform, 'sendToOrigin', ov);
      } else if (type === "disabled") {
        this.$set(transform.transform, 'disabled', ov);
      } else if (type === "unparent") {
        this.$set(transform.transform, 'unparent', ov);
      } else {
        throw new Error("dont know how to transform update undo: " + type);
      }

      //this.$set(this.selections, transform.id, true);

      this.queueTransformSelection(transform);
    },
    redoTransformUpdate({transformId, type, nv, ov}) {
      this.undoTransformUpdate({
        transformId,
        type,
        nv:ov,
        ov:nv
      });
    },
    onAddRecommendation({addedComponents, addedLinks}) {
      this.addToUndo({
        type:'addComponents',
        data:{
          addedComponents,
          addedLinks
        }
      });
      return true;
    },
    onTransformUpdate({transform, transformId, type, nv, ov}) {
      this.addToUndo({
        type:'transformUpdate',
        data:{
          transformId,
          transform,
          nv,
          ov,
          type,
        }
      });
    },
    undoAddChild({newChildren, newParents, newComponents}) {
      const transformsToRemove = zip(newParents, newChildren).map( ([parent, child]) => {
        return {parent, child}
      });
      const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(transformsToRemove);
      this.redoStack.push({
        type:'addChild',
        data:{
          removedChildren,
          removedParents,
          removedComponents,
          removedLinks
        }
      });
      this.clearSelections();
      return true;
    },
    undoAddComponents({addedComponents, addedLinks}) {
      const {components, links} = this.partutil.from;
      const treeutil = new Treeutil({components, links});
      const {removedComponents, removedLinks} = treeutil.removeComponentsAndLinks(addedComponents, addedLinks);

      this.redoStack.push({
        type:'addComponents',
        data:{
          removedComponents,
          removedLinks
        }
      });
      return true;
    },
    redoAddComponents({removedComponents, removedLinks}) {
      const {components, links} = this.partutil.from;
      const treeutil = new Treeutil({components, links});
      const {addedComponents, addedLinks} = treeutil.addComponentsAndLinks(removedComponents, removedLinks);
      this.undoStack.push({
        type:'addComponents',
        data:{
          addedComponents,
          addedLinks
        }
      });
      return true;
    },
    undoRemoveComponents({removedLinks,removedComponents}) {
      const {components, links} = this.partutil.from;
      const treeutil = new Treeutil({components, links});
      const {addedComponents, addedLinks} = treeutil.addComponentsAndLinks(removedComponents, removedLinks);
      this.redoStack.push({
        type:'removeComponents',
        data:{
          addedComponents,
          addedLinks
        }
      });
      return true;
    },
    redoRemoveComponents({addedComponents,addedLinks}) {
      const {components, links} = this.partutil.from;
      const treeutil = new Treeutil({components, links});
      const {removedComponents, removedLinks} = treeutil.removeComponentsAndLinks(addedComponents, addedLinks);
      
      this.undoStack.push({
        type:'removeComponents',
        data:{
          removedComponents,
          removedLinks
        }
      });
      return true;
    },
    redoAddChild({removedChildren, removedComponents, removedParents, removedLinks}) {
      const {addedChildren, addedParents, addedComponents, addedLinks} = this.partutil.addTransformsAndStuff(removedParents, removedChildren, removedComponents, removedLinks);
      this.addToUndo({
        type:'addChild',
        data:{
          newChildren: addedChildren,
          newComponents: addedComponents,
          newParents: addedParents
        }
      }, false);

      /*
      this.clearSelections();

      addedChildren.forEach( (newChild) => {
        this.queueTransformSelection(newChild);
      });
      */

      return true;
    },
    undoRemoveChild({removedParents, removedChildren, removedComponents, removedLinks}) {
      const {addedChildren, addedParents, addedComponents, addedLinks} = this.partutil.addTransformsAndStuff(removedParents, removedChildren, removedComponents, removedLinks);

      this.redoStack.push({
        type: 'removeChild',
        data:{
          addedChildren, addedParents
        }
      });

      /*
      this.clearSelections();
      addedChildren.forEach( (child) => {
        this.queueTransformSelection(child);
      });
      */

      return true;
    },
    redoRemoveChild({addedChildren, addedParents}) {
      const transformsToRemove = zip(addedParents, addedChildren).map( ([parent, child]) => {
        return {
          parent,
          child
        }
      });
      const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(transformsToRemove);
      this.addToUndo({
        type:'removeChild',
        data:{
          removedChildren,
          removedParents,
          removedComponents,
          removedLinks
        }
      }, false);
      return true;
    },
    undoInstanceTransform({addedChildren,addedParents}) {
      const transformsToRemove = zip(addedParents, addedChildren).map( ([parent, child]) => {
        return {
          parent,
          child
        }
      });
      const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(transformsToRemove);
      this.redoStack.push({
        type:'instanceTransform',
        data:{
          removedChildren,
          removedParents,
          removedComponents,
          removedLinks
        }
      });
      return true;
    },
    redoInstanceTransform({removedChildren, removedParents, removedComponents, removedLinks}) {
      const {addedChildren, addedParents, addedComponents, addedLinks} = this.partutil.addTransformsAndStuff(removedParents, removedChildren, removedComponents, removedLinks);

      this.addToUndo({
        type: 'instanceTransform',
        data:{
          addedChildren,
          addedParents,
          addedComponents,
          addedLinks
        }
      }, false);

      this.clearSelections();
      addedChildren.forEach( (child) => {
        this.queueTransformSelection(child);
      });

      return true;
    },
    undoDuplicate({addedChildren, addedLinks, addedParents, addedComponents}) {
      const transformsToRemove = zip(addedParents, addedChildren).map( ([parent, child]) => {
        return {
          parent,
          child
        }
      });
      const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(transformsToRemove);
      this.redoStack.push({
        type:'duplicate',
        data:{
          removedChildren,
          removedParents,
          removedComponents,
          removedLinks
        }
      });

      return true;
    },
    redoDuplicate({removedChildren, removedParents, removedComponents, removedLinks}) {
      const {addedChildren, addedParents, addedComponents, addedLinks} = this.partutil.addTransformsAndStuff(removedParents, removedChildren, removedComponents, removedLinks);

      this.addToUndo({
        type: 'duplicate',
        data:{
          addedChildren,
          addedParents,
          addedComponents,
          addedLinks
        }
      }, false);

      this.clearSelections();
      addedChildren.forEach( (child) => {
        this.queueTransformSelection(child);
      });

      return true;
    },
    undoUpdateComponent({transform, ov, nv}) {
      console.log('undo update component', nv.id, ov.id, ov.text, nv.text);
      const component = this.partutil.getComponentById(ov.id);
      Object.assign(component, ov);
    },
    redoUpdateComponent({transform, ov, nv}) {
      console.log('redo update component', nv.id, ov.id, ov.text, nv.text);
      const component = this.partutil.getComponentById(ov.id);
      Object.assign(component, nv);
    },
    undoSetCanvasSize({prevSize,newSize}) {
      console.log('undo Set canvas size', prevSize.cols, prevSize.rows);
      this.$set(this.gameSize, 'cols', prevSize.cols);
      this.$set(this.gameSize, 'rows', prevSize.rows);
      this.updateSize();
    },
    redoSetCanvasSize({prevSize,newSize}) {
      console.log('redo Set canvas size', newSize.cols, newSize.rows);
      this.$set(this.gameSize, 'cols', newSize.cols);
      this.$set(this.gameSize, 'rows', newSize.rows);
      this.updateSize();
    },
    clearSelections() {
      Object.keys(this.selections).forEach( (id) => {
        this.$set(this.selections, id, false);
      });
      Object.keys(this.indirectSelections).forEach( (id) => {
        this.$set(this.indirectSelections, id, false);
      });
      this.possibleSelections = [];
    },
    getSelection(id) {
      // TODO: this was called findSelections, did we rely on
      // indirect / direct confusion somewhere?
      return this.selectionsById[id];
    },
    queueSceneObjectUpdate(transform) {
      const selectedData = this.getSelection(transform.id);
      if (!selectedData) {
        this.queuedSceneObjectUpdates[transform.id] = true;
        return;
      }
      const {holder,updateContainerBounds} = selectedData;
      this.renderTools.addToRunBatch( () => {
        holder.updateSceneObjects();
        updateContainerBounds(true);
      });
    },
    queueTransformUpdate(transform) {
      const selectedData = this.getSelection(transform.id);
      if (!selectedData) {
        if (this.holderData[transform.id]) {
          const {holder} = this.holderData[transform.id];
          this.renderTools.addToUpdateBatch(holder);
          this.queuedTransformUpdates[transform.id] = true;
        }
        return;
      }
      const {holder,updateContainerBounds} = selectedData;
      this.renderTools.addToUpdateBatch(holder);
      this.renderTools.addToRunBatch( () => {
        updateContainerBounds(true);
      });
    },
    queueTransformSelection(transform) {
      this.renderTools.addToRunBatch( () => {
        if (!transform) {
          console.error('why u break?!?');
          return;
        }
        const indirects = this.setIndirects(transform);
        this.$set(this.selections, transform.id, true);
        this.queueTransformUpdate(transform);
        this.queueTransformUpdates(indirects);
        this.queueSceneObjectUpdate(transform);

      });

      this.possibleSelections.push({
        transform
      });
      this.possibleSelections = uniqBy(this.possibleSelections, ({transform:id}) => {
        return id;
      });
      this.viewInfo({transform});

    },
    queueTransformSelections(transforms) {
      transforms.forEach( (t) => {
        this.queueTransformSelection(t);
      });
    },
    setIndirects(transform) {
      // TODO: this is duplicated between UndoRenderer and EditRenderer :-(
      const allChildren = this.partutil.findAllChildrenFromTransform(transform);
      allChildren.forEach( (child) => {
        if (child.id !== transform.id) {
          this.$set(this.indirectSelections, child.id, true);
          this.$set(this.selections, child.id, true);
        } else {
          this.$set(this.indirectSelections, child.id, false);
          this.$set(this.selections, child.id, true);
        }
      });
      return allChildren;
    },
    queueTransformUpdates(transforms) {
      this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          this.renderTools.addToRunBatch( () => {
            transforms.forEach( (t) => {
              this.queueTransformUpdate(t);
            });
          });
        });
      });
    },
    addToUndo(data, clearRedo=true) {
      this.undoStack.push(data);
      if (clearRedo) {
        this.redoStack.splice(0, this.redoStack.length);
      }

      this.$ana.track({
        eventCategory: 'action',
        eventAction: data.type
      });
    },
    closeAddTransformWizard() {
      this.addingToParents = [];
    },
    closeAddComponentWizard() {
      this.addingToComponents = [];
      this.autoLinkRecommendation = undefined;
      this.$eventbus.emit('closeAddComponentWizard');
    },
    positionChildren({children, parents}) {
      this.positionNewChildren(children, parents);
    },
    selectChildren({children, parents, components}) {
      this.clearSelections();

      children.forEach( (newChild) => {
        this.queueTransformSelection(newChild);
      });

      if (children.length === 1) {
        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          this.viewInfo({transform:children[0]});
        });
        });
      }

    },
    onShowSetDuration({transform}) {
      if (!this.isAdvancedMode) {
        const holderData = this.holderData[transform.id];
        if (!holderData) {
          this.renderTools.addOnReadyEvent(transform, (holder) => {
            this.queueTransformSelection(transform);
            this.onInstantDuration({transform});
          });
        } else {
          this.queueTransformSelection(transform);
          this.onInstantDuration({transform});
        }
      }

    },
    addChildren({newChildren, newParents, newComponents}) {

      this.addToUndo({
        type:'addChild',
        data:{
          newChildren,
          newComponents,
          newParents
        }
      });

      this.closeAddTransformWizard();

      this.$ana.track({
        eventCategory:'place',
        eventAction:'placeNewToy',
        extra:{
          type:newComponents[0].type
        }
      });

    },
    positionNewChildren(newChildren, newParents) {
      newChildren.forEach( (child,i) => {
        // TODO: ??? make this use that other event thingy
        this.renderTools.addOnReadyEvent(child.id, () => {
          const parent = newParents[i];
          const holderData = this.holderData[parent.id];

          const center = this.$refs.editRenderer.getScreenCanvasCenterPoint();
          // chop off a 80px just for fun, especially for phones
          let newPos,newPos2,newPos3,newPos4;
          let container;
          if (holderData) {
            container = this.$refs.editRenderer.$refs.renderer.container;
            const stage = this.$refs.editRenderer.$refs.renderer.pixiApp.stage;
            const holder = holderData.holder;

            holder.getContainer().updateTransform();
            center.x -= stage.pivot.x;
            center.y -= stage.pivot.y;

            const pos = holder.getContainer().worldTransform.applyInverse(center);
            const worldPos = {
              x:this.renderTools.screenToWorld_x(pos.x, true),
              y:this.renderTools.screenToWorld_y(pos.y, true)
            }

            child.transform.pos.x = worldPos.x;
            child.transform.pos.y = worldPos.y;

          } else {
            container = this.$refs.editRenderer.$refs.renderer.container;

            newPos = container.localTransform.applyInverse(center);

            const worldPos = {
              x:this.renderTools.screenToWorld_x(newPos.x),
              y:this.renderTools.screenToWorld_y(newPos.y)
            }
            if (holderData) {
              //worldPos.x -= parent.transform.pos.x;
              //worldPos.y -= parent.transform.pos.y;
            }
            child.transform.pos.x = worldPos.x;
            child.transform.pos.y = worldPos.y;

          }

          const childHolder = this.holderData[child.id].holder;
          this.renderTools.addToUpdateBatch(childHolder);


        });
      });
    },
    addComponents({addedComponents, addedLinks}) {
      this.addToUndo({
        type:'addComponents',
        data:{
          addedComponents,
          addedLinks
        }
      });
      const component = addedComponents[0];
      if (this.$refs.transformEditComponents) {
        this.$refs.transformEditComponents.forceSelectComponent({component:{}});
      }
      this.autoLinkRecommendation = undefined;
      this.$ana.track({
        eventCategory:'place',
        eventAction:'placeNewComponent',
        extra:{
          type:addedComponents[0].type
        }
      });
    },
    removeComponents({removedComponents,removedLinks,transforms}) {
      this.addToUndo({
        type:'removeComponents',
        data:{
          removedComponents,
          removedLinks
        }
      });
    },
    changeEditingComponent(component) {
      this.editingComponent = component;
    },
    play() {
      this.$emit("play");
    },
    onPanStart() {
      this.isPanning = true;
    },
    onPanEnd() {
      this.isPanning = false;
    },
    onZoomStart() {
      //this.isPanning = true;
    },
    onZoomEnd() {
      //this.isPanning = false;
    },
    _resized(a) {
      if (this.$vhcheck) {
        this.$vhcheck.emit('recompute');
      }
      if (this.$refs.editRenderer) {

        if (this.enableTemplateJumpingFeature && this.__templateInputFocused) {
          const bb = this.$el.getBoundingClientRect();
          const keyboardOpen = true;
          //const keyboardOpen = true;
          //alert("bb: " + bb.height + " - " + window.visualViewport.height);
          if (!keyboardOpen) {
            this.delayedCenter(null, true);
          } else {
            this.delayedCenter({x:0,y:4});
          }
          return;
        } else {
          if (this.__templateInputFocused) {
            this.$refs.editRenderer.resizeCanvas();
            window.requestAnimationFrame( () => {
              this.$refs.editRenderer.updateAllContainerBounds();
            });
            /*
            window.requestAnimationFrame( () => {
              const bb = this.$el.getBoundingClientRect();
              const keyboardOpen = bb.height < 0.7*this.lolVisualHeight;
              if (keyboardOpen) {
                this.delayedCenter({x:0,y:4});
              } else {
                this.delayedCenter(null, true);
              }
            });
            */
          } else {
            this.$refs.editRenderer.resizeCanvas();
            window.requestAnimationFrame( () => {
              this.$refs.editRenderer.updateAllContainerBounds();
            });
          }
        }

      }
    },
    addLinkRecommendation({link, addedComponents,addedLinks}) {
      this.addingToComponents = addedComponents;
      this.autoLinkRecommendation = link;

      const component = addedComponents[0];
      this.$refs.transformEditComponents.forceMoveToComponent({
        component
      });
      //this.addingToComponents = addingToComponents;
    },
    quickScale(transform, delta) {
      const {scale} = transform.transform;
      const ratio = scale.y / scale.x;
      transform.transform.scale.x = (1 + delta) * scale.x;
      transform.transform.scale.y = ratio * scale.x;
      const holder = this.holderData[transform.id];
      this.renderTools.addToUpdateBatch(holder);
    },
    isOutsideCamera(pos) {
      const {rows,cols} = this.gameSize;

      return pos.x <= -cols/2 || pos.x >= cols/2 || pos.y <= -rows/2 || pos.y >= rows/2;
    },
    calculateNoTransformsAdded() {
      const gamedata = this.transformsAndSource.gamedata;
      if (!this.hasTemplate || this.isAdvancedMode) {
        if (this.transformsAndSource.from.transforms.length <= 1) {
          const allTransforms = [];
          this.partutil.findAllChildren(allTransforms);
          const nonCamera = allTransforms.filter( (transform) => {
            const c = this.partutil.findComponentForTransform(transform);
            return c.type !== 'camera';
          });
          this.$store.commit('setNoTransformsAdded', nonCamera.length === 0);
        } else {
          this.$store.commit('setNoTransformsAdded', false);
        }
      } else {
        const filledInComponents = [];
        this.template.components.forEach( ({component}) => {
          const c = this.partutil.getComponentById(component);
          if (!c) {
            console.error('couldnt find template component');
            return;
          }
          if (c.text !== '') {
            filledInComponents.push(c);
          }
        });
        if (filledInComponents.length) {
          this.$store.commit('setNoTransformsAdded', false);
        } else {
          this.$store.commit('setNoTransformsAdded', true);
        }
      }
    },
    quickAddToy() {
      this.$refs.toolbar.add();
    },
    isFunky(transform) {
      const c = this.partutil.findComponentForTransform(transform);
      if (c) {
        return findDbEntry(c).funky;
      } else {
        return false;
      }
    },
    onInstandAdd() {
      this.$refs.toolbar.add();
    },
    onInstantDuration({transform}) {
      this.showEffects = true;
      this.animateTransform = transform || {};
    },
    zoomIn() {
      this.$refs.editRenderer.zoomIn();
    },
    zoomOut() {
      this.$refs.editRenderer.zoomOut();
    },
    getSelectedWorldPos(pos) {
      // find the first selection
      const firstSelection = toPairs(this.selections).filter( ([id,selected]) => {
        return selected;
      }).map( ([id]) => id )[0];

      const holderData = this.holderData[firstSelection];
      const holder = holderData.holder;

      const container = holder.getContainer();
      const worldPos = this.renderTools.getWorldPosition(container, {x:0,y:0});
      if (pos) {
        worldPos.x += pos.x;
        worldPos.y += pos.y;
      }
      return worldPos;
    },
    center(pos, skipSelection) {
      if (skipSelection || !this.hasSelections) {
        this.$refs.editRenderer.gotoCenter();
      } else {
        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
        this.renderTools.addToRunBatch( () => {
          const worldPos = this.getSelectedWorldPos(pos);
          this.$refs.editRenderer.gotoPosition(worldPos);
        });
        });
        });

      }
    },
    onChangeCenter({x,y}) {
      this.editRendererCenter.x = x;
      this.editRendererCenter.y = y;
    },
    onDeselectAll() {
      this.clearSelections();
      this.onDeselect();
    },
    onDeselect() {
      this.viewingInfoTransform = {};
      this.possibleSelections = [];
    },
    onPossibleSelections({possibleSelections, dontAutoSelect}) {
      if (!this.enableSelection) {
        this.clearSelections();
        this.onDeselect();
        return;
      }
      
      if (this.selectionsBlockedByTemplate) {
        possibleSelections = possibleSelections.filter( ({transform}) => {
          return !this.blockedTemplateSelections.includes(transform.id);
        });
        if (!possibleSelections.length) {
          this.clearSelections();
        }
      }

      if (!possibleSelections || !possibleSelections.length) {
        this.onDeselect();
        return;
      }

      possibleSelections = orderBy(possibleSelections, ({transform}) => {
        return this.renderTools.getCanonicalZindex(transform);
      });
      possibleSelections.reverse();


      this.possibleSelections = possibleSelections;
      this.selectNextPossibleSelection();
      /*
      if (!dontAutoSelect) {
        const firstSelection = possibleSelections[0];
        this.viewingInfoTransform = {};
        this.$refs.editRenderer.selectOne(firstSelection.transform);
      }

      this.possibleSelections = possibleSelections;
      this.viewInfo(possibleSelections[0]);

      this.previousPossisbleSelections = possibleSelections;
      */
    },
    togglePossibleSelection({transform}) {
      if (!this.selections[transform.id]) {
        this.viewingInfoTransform = {};
        this.$refs.editRenderer.selectOne(transform);
        this.queueTransformSelection(transform);
      } else {
        if (this.indirectSelections[transform.id]) {
          this.viewingInfoTransform = {};
          this.$refs.editRenderer.selectOne(transform);
          this.queueTransformSelection(transform);
        } else {
          this.queueTransformSelection(transform);
        }
      }
    },
    getPossibleSelectionState({transform}) {
      if (this.selections[transform.id]) {
        if (this.viewingInfoTransform.id === transform.id) {
          return 'info';
        } else {
          if (!this.indirectSelections[transform.id]) {
            return 'selected';
          } else {
            return 'not-selected';
          }
        }
      } else {
        return 'not-selected';
      }
    },
    getPossibleSelectionIcon(transform) {
      const type = this.getPossibleSelectionState({transform});
      if (type === 'info') {
        return Information;
      } else if (type === 'selected') {
        return ArrowUpThick;
      } else if (type === 'not-selected') {
        return SelectIcon;
      }
    },
    makePossibleSelectionClass({transform}) {
      const type = this.getPossibleSelectionState({transform});
      if (type === 'info') {
        return 'pbc-possible-selection-info';
      } else if (type === 'selected') {
        return 'pbc-possible-selection-selected';
      } else if (type === 'not-selected') {
        return 'pbc-possible-selection-not-selected';
      }
    },
    updateLayer({transform}) {
      this.queueTransformUpdate(transform);
    },
    onInstantAddFromSpritesheet({image,spritesheet}) {
    },
    onInstantMode(mode) {
      this.instantMode = mode;
      this.$ana.track({
        eventCategory: 'instant',
        eventAction: mode
      });
    },
    onAddAdvancedMode() {
      this.showSimpleAdd = false;

      const parents = this.__tmpParents;
      const childrenComponents = this.__tmpChildrenComponents;

      this.startAddTransforms({parents,childrenComponents});
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'advancedAdd'
      });
    },
    onSetForeground() {
      this.currentLayer = 'foreground';
    },
    onSetBackground() {
      this.currentLayer = 'background';
    },
    getLayersFromPacks(packs) {
      const layers = flatten(packs.map( ({items}) => {
        return items.map( ({layer}) => {
          return layer;
        });
      }));
      //, ({layers}) => {
        //return layers;
      //});
      const uniqLayers = uniqBy(layers, ({name}) => {
        return name;
      });
      return uniqLayers;
    },
    onClearLayer(layer) {
      const toClear = [];
      const transforms = this.transformsAndSource.gamedata.findAllTransforms();
      transforms.forEach( (transform) => {
        if (transform.transform.layer === layer.id) {
          toClear.push({parent:this.partutil.root,child:transform});
        }
      });

      const {removedChildren, removedParents, removedComponents, removedLinks} = this.partutil.removeTransforms(toClear);
    },
    onChangeComponents() {
      this.$emit("force-autosave");
    },
    autoRemixData(gamedata) {
      const data = gamedata.__autoRemixData;
      console.log('autoremix', JSON.stringify(data,0,2));
      if (data.aspect) {
        console.log('check aspect!!!!!!!', data.aspect);
        const game = this.transformsAndSource.gamedata.gamedata.game;
        const [cols,rows] = data.aspect.split('x').map(parseFloat);
        console.log('SET ASPECT TO', cols, rows);
        game.cols = cols;
        game.rows = rows;
      }
      if (!data.animation && (data.image || data.spritesheet)) {
        const {layer,toysheet,image,spritesheet,position} = data;
        const partutil = this.partutil;
        const renderTools = this.renderTools;

        const newComponent = ComponentsDb.types.sprite.createNew();
        if (spritesheet) {
          Object.assign(newComponent, {
            atlas:spritesheet.id,
            texture:image.name,
            sprite:image.name,
            firstLoad:true
          });
        } else {
          Object.assign(newComponent, {
            sprite:image.id,
            firstLoad:true
          });
        }

        this.partutil.selectLayer(layer);

        const {
          newChildren,
          newParents,
          newComponents,
        } = this.partutil.addChildren([this.partutil.root], newComponent);

        newChildren.forEach( (child) => {
          child.transform.pos.x = 0
          child.transform.pos.y = 0
        });

        console.log('SCALE IS SET TO', data);
        if (data.scale) {
          console.log('add on ready event');
          renderTools.addOnReadyEvent(newChildren[0], (holder) => {
            if (data.scale === 'contain') {
              holder.scaleContain();
            } else {
              holder.scaleCover();
            }
            renderTools.addToRunBatch( () => {
              renderTools.addToUpdateBatch(holder);
            });
          });
        }


        delete gamedata.__autoRemixData;
      } else if (data.animation) {
        gamedata.uploadedImages.push({
          __type:'animation',
          ...data.animation
        });

        const renderTools = this.renderTools;
        const {layer, animation} = data;
        const {newChildren, newComponents, newParents, sprite} = this.partutil.addSprite(this.partutil.root, layer);
        sprite.anim = true;
        sprite.anims = [{
          frames:JSON.parse(animation.frames),
          loopByDefault: animation.loopByDefault,
          timePerFrame: animation.timePerFrame
        }]
        sprite.atlas = sprite.anims[0].frames[0].atlas;
        sprite.sprite = sprite.anims[0].frames[0].texture;
        sprite.texture = sprite.anims[0].frames[0].texture;
        console.log('have sprite', sprite);

        newChildren.forEach( (child) => {
          child.transform.scale.x = 1.4;
          child.transform.scale.y = 1.4;
          child.transform.pos.x = 0
          child.transform.pos.y = 0
        });

        console.log('2SCALE IS SET TO', data.scale);
        if (data.scale) {
          console.log('2add on ready event');
          renderTools.addOnReadyEvent(newChildren[0], (holder) => {
            if (data.scale === 'contain') {
              holder.scaleContain();
            } else {
              holder.scaleCover();
            }
            renderTools.addToRunBatch( () => {
              renderTools.addToUpdateBatch(holder);
            });
          });
        }

        delete gamedata.__autoRemixData;
      }
    },
    autoRemixImage(gamedata) {
      console.log('auto remix image');
      if (gamedata.__autoRemixImage) {
        gamedata.uploadedImages.push({
          __type:'image',
          id:gamedata.__autoRemixImage
        });
        const partutil = this.partutil;
        const renderTools = this.renderTools;
        const layer = {
          id:'default',
          name:'Foreground',
          zindex:1,
          projection:'orthogonal',
          direction:'rightdown'
        }
        const position = {
          x: 0,
          y: 0
        }

        const id = gamedata.__autoRemixImage;
        delete gamedata.__autoRemixImage;
        const {newChildren,newParents,newComponents} = partutil.addImageFromSpritesheet({
          layer,
          image:{id},
          position,
        });

        const component = newComponents[0];
        const transform = newChildren[0];

        renderTools.addOnReadyEvent(newChildren[0], (holder) => {
          holder.scaleContain();
          renderTools.addToRunBatch( () => {
            renderTools.addToUpdateBatch(holder);
          });
        });
      }
    },
    selectFirstTransform() {
      const gamedata = this.transformsAndSource.gamedata;
      if (this.transformsAndSource.from.transforms.length <= 1) {
        const allTransforms = [];
        this.partutil.findAllChildren(allTransforms);
        const nonCamera = allTransforms.filter( (transform) => {
          const c = this.partutil.findComponentForTransform(transform);
          return c.type !== 'camera';
        });
        this.$store.commit('setNoTransformsAdded', nonCamera.length === 0);
      } else {
        const allTransforms = [];
        this.partutil.findAllChildren(allTransforms);

        const first = allTransforms.filter( (transform) => {
          const c = this.partutil.findComponentForTransform(transform);
          return c && this.isSelectableLayer(transform.transform.layer) && (c.type === "sprite" || c.type === "text");
        })[0];

        this.queueTransformSelection(first);
        //this.$store.commit('setNoTransformsAdded', false);
      }
    },
    checkKeepRatio(transform) {
      if (!transform || !transform.id) {
        return;
      }
      const component = this.partutil.findComponentForTransform(transform);
      if (!component) {
        return;
      }
      if (component.type === 'text') {
        this.$store.commit('setDraggingKeepRatio', false);
      } else {
        this.$store.commit('setDraggingKeepRatio', true);
      }
    },
    onTemplateChangeComponent({nv,ov,transform}) {
      console.log('nvvvvvv', JSON.stringify(nv,0,2));
      console.log('ovvvvvv', JSON.stringify(ov,0,2));
      this.addToUndo({
        type:'updateComponent',
        data:{
          nv,
          ov,
          transform
        }
      });
      this.onChangeComponents();
    },
    onShowAnimate() {
      if (this.viewingInfoTransform.id) {
        this.onInstantDuration({transform:this.viewingInfoTransform});
      } else {
        const allTransforms = [];
        this.partutil.findAllChildren(allTransforms);
        const nonCamera = allTransforms.filter( (transform) => {
          const c = this.partutil.findComponentForTransform(transform);
          return c.type !== 'camera';
        });
        this.onInstantDuration({transform:nonCamera[0]})

      }
    },
    updateSize() {
      // TODO: why u no work in gameSize watcher
      const game = this.transformsAndSource.gamedata.gamedata.game;
      const {rows,cols} = this.gameSize;
      game.cols = cols;
      game.rows = rows;
    }
  },
  watch:{
    sizeCanvas(nv) {
      if (nv) {
        this.sizeCanvasPreviousSize = {
          ...this.gameSize
        }


      } else {
        const prevSize = {
          ...this.sizeCanvasPreviousSize
        };
        const newSize = {
          ...this.gameSize
        };
        console.log('add to undo', prevSize, newSize);
        this.updateSize();
        this.addToUndo({
          type:'setCanvasSize',
          data:{
            prevSize,
            newSize
          }
        });
      }
    },
    currentTemplateMode(nv) {
      if (this.enableTemplateJumpingFeature) {
        this.delayedCenter();
      } else {
        this.resized();
      }
    },
    templateMode(nv) {
      if (this.enableTemplateJumpingFeature) {
        this.delayedCenter();
      } else {
        this.resized();
      }
    },
    quickEdit(nv) {
      this.resized();
    },
    'viewingInfoTransform.id'() {
      this.quickEdit = '';

      if (this.hasTemplate) {
        const selectedId = this.viewingInfoTransform.id;

        const hasSelectedTemplateItem = this.template.components.filter( ({transform,component}) => {
          return selectedId === transform;
        }).length > 0;
        if (!hasSelectedTemplateItem && this.currentTemplateMode === "editTemplate") {
          console.log('3333333333333333333333');
          this.$store.commit('setTemplateMode', false);
          this.currentTemplateMode = "editTemplate";
        } 
        if (hasSelectedTemplateItem && !this.currentTemplateMode !== "editTemplate") {
          console.log('222222222222222222222222');
          this.$store.commit('setTemplateMode', true);
          this.currentTemplateMode = "editTemplate";
        }

      }

      this.checkKeepRatio(this.viewingInfoTransform);

      const component = this.partutil.findComponentForTransform(this.viewingInfoTransform);
      this.$emit('select', {
        transform:this.viewingInfoTransform,
        component:component
      });
    },
    showEffects(nv) {
      if (nv) {
        this.$emit("animate");
      } else {
        this.$emit("placement");
      }
    },
    isAdvancedMode() {
      this.$refs.editRenderer.resizeCanvas();
      this.$refs.editRenderer.gotoCenter();
      this.calculateNoTransformsAdded();
    },
    showSimpleAdd(nv) {
      if (!nv) {
        this.hideSimpleAddForPlacing = false;
      }
    },
    'selections':{
      handler(nv) {
        const isAnySelected = Object.values(nv).filter( (selected) => {
          return selected;
        }).length;
        if (!isAnySelected) {
          this.editingComponents = false;
        }
      },
      deep:true
    },
    'selectionsData.length'(nv) {
      this.selectionsById = {};
      this.selectionsData.forEach( ({transform,holder,updateContainerBounds}) => {
        this.selectionsById[transform.id] = {
          holder,
          updateContainerBounds
        }
        if (this.queuedTransformUpdates[transform.id]) {
          this.queueTransformUpdate(transform);
          delete this.queuedTransformUpdates[transform.id];
        }
        if (this.queueSceneObjectUpdate[transform.id]) {
          this.queueSceneObjectUpdate(transform);
          delete this.queuedSceneObjectUpdates[transform.id];
        }
      });

      if (nv.length === 0) {
        this.editingComponents = false;
      }

    },

    editingComponents(nv) {
      if (nv) {
        this.$ana.track({
          eventCategory:'editor',
          eventAction: 'showEditComponents'
        });
        this.undoStack.splice(0, this.undoStack.length);
        this.redoStack.splice(0, this.redoStack.length);
      } else {
        this.$ana.track({
          eventCategory:'editor',
          eventAction:'showEditTransforms'
        });
        this.undoStack.splice(0, this.undoStack.length);
        this.redoStack.splice(0, this.redoStack.length);

        if (this.templateMode) {
          this.calculateNoTransformsAdded();
        }
      }
    },

    'undoStack.length'() {
      this.$emit("add-undo");
      this.calculateNoTransformsAdded();
    },
    editLayers(nv) {
      this.$ana.track({
        eventCategory: 'ui',
        eventAction: 'editLayers',
        extra:{nv}
      });
    },
    selectedLayers: {
      handler(nv) {
        Object.keys(nv).forEach( (layerId) => {
          if (nv[layerId]) {
            const layer = this.layers[layerId];
            this.partutil.selectLayer(layer);
          }
        });
      },
      deep:true,
      immediate:true
    }

  },
  computed: {
    gamedata() {
      return ((this.transformsAndSource||{}).gamedata||{}).gamedata;
    },
    showMoreButton() {
      return !this.isAnonymous || this.$route.name == 'editTemplate';
    },
    templateCustomizerVerticalPosition() {
      if (this.selectedTransformWorldPos.y >= 3) {
        return 'top-0';
      } else {
        return 'bottom-0 mb-16'
      }
    },
    selectionsBlockedByTemplate() {
      //return this.hasTemplate && this.template.blockSelections;
      return this.hasTemplate;
    },
    blockedTemplateSelections() {
      return this.template.blockedSelections || [];
    },
    gotoNextTemplateItem() {
      return this.hasTemplate && this.showTemplateCustomizer && !this.isLastTemplateComponent;
    },
    nextIsPost() {
      return true;
      const game = this.transformsAndSource.gamedata.gamedata.game;
      return game.timelimit === -1 || (this.showTemplateCustomizer && this.isLastTemplateComponent) || (this.filledInTemplate && !this.viewingInfoTransform.id);
      //return (this.showTemplateCustomizer && this.isLastTemplateComponent) || (this.filledInTemplate && !this.viewingInfoTransform.id) || (this.hasTemplate && this.viewingInfoTransform.id)
    },
    filledInTemplate() {
      return this.hasTemplate  && !this.noTransformsAdded;
    },
    showTemplateChanger() {
      return this.hasTemplate && this.templateMode && this.currentTemplateMode === "chooseTemplate" && !this.showEffects
    },
    showTemplateCustomizer() {
      return this.hasTemplate && this.templateMode && this.currentTemplateMode === "editTemplate" && !this.showEffects;
    },
    gameSize() {
      const game = this.transformsAndSource.gamedata.gamedata.game;
      const rows = game.rows || 16;
      const cols = game.cols || 12;
      return {
        cols,
        rows
      }
    },
    /*
      get() {
        const game = this.transformsAndSource.gamedata.gamedata.game;
        const rows = game.rows || 16;
        const cols = game.cols || 12;
        return {
          cols,
          rows
        }
      },
      set(nv) {
        console.log('!!!!!!!!!nvvvvvvvv', nv);
      }
    },
    */
    hasTemplate() {
      return !this.isAdvancedMode && !!this.template.version;
    },
    showAwesomeBar() {
      return !this.isAdvancedMode && !this.showEffects;
    },
    showToolbar() {
      return this.isAdvancedMode && !this.showEffects;
    },
    isAnonymous() {
      return !this.$store.state.loggedIn;
    },
    showTransformInfo() {
      return !!(!this.isPanning && !this.isDragging && !this.editingComponents && this.viewingInfoTransform.id);
    },
    historySelectionsData: {
      get() {
        const selections = toPairs(this.selections).filter( ([key,value]) => {
            return value;
        }).map( ([key,value]) => {
          return key;
        }).join(",");
        const indirectSelections = toPairs(this.selections).filter( ([key,value]) => {
            return value;
        }).map( ([key,value]) => {
          return key;
        }).join(",");
        return {
          selections,
          indirectSelections
        }
      },
      set(data) {
        const selections = (data||{}).selections || ''
        const indirectSelections = (data||{}).indirectSelections || '';
        this.selections = fromPairs(selections.split(",")
          .filter( (key) => {
            return key !== ''
          })
          .map( (key) => {
          return [key,true];
        }));
        this.indirectSelections = fromPairs(indirectSelections.split(",")
          .filter( (key) => {
            return key !== ''
          })
          .map( (key) => {
            return [key,true];
          }));
      }
    },
    historyAddTransformsData: {
      get() {
        return this.addingToParents.map( ({id}) => { return id; });
      },
      set(nv) {
        if (typeof(nv) === 'undefined') {
          this.addingToParents = [];
          this.addingToComponents = [];
        } else {
          if (nv.length) {
            // lets hope the state is correct lol
            this.$refs.toolbar.add();
          } else {
            this.addingToParents = [];
            this.addingToComponents = [];
          }
        }
      },
    },
    historyAddComponentsData: {
      get() {
        return this.addingToComponents
          .map( ({id}) => { return id; })
          .length > 0;
      },
      set(nv) {
        if (typeof(nv) === 'undefined') {
          nv = false
        }
        if (nv && !this.editingComponents) {
          this.$refs.toolbar.add();
        } else {
          if (this.addingToParents.length) {
            this.addingToParents = [];
            this.addingToComponents = [];
          }
        }
      },
    },
    historyEditingComponents: {
      get() {
        return this.editingComponents;
      },
      set(nv) {
        this.editingComponents = nv;
      }
    },
    hasSelections() {
      return !!this.selectionsData.length;
    },
    cameraNotCenter() {
      const selectionsLength = this.selectionsData.length;

      if (!this.hasSelections) {
        const currentCenter = {
          x: 0,
          y: 0
        }
        return Math.abs(this.editRendererCenter.x - currentCenter.x) > 7 && Math.abs(this.editRendererCenter.y - currentCenter.y) > 7;
      } else {
        return true;
      }

    },
    editingMode() {
      return this.instantMode;
    },
    enableSelection() {
      return true;
    },
    ctaMessage() {
      if (this.hasSelections) {
        return "Add animations, movement for this toy."
      }
      if (this.instantMode === "" || this.instantMode === "choosepack") {
        if (this.noTransformsAdded) {
          if (this.isAdvancedMode) {
            return "Select a Pack to Get Started.";
          } else {
            if (!this.hasTemplate) {
              return "Press Add to get started.";
            } else {
              return "Tap the text to get started.";
            }
          }
        } else {
          return "Select a Layer (eg. Background,foreground) to try different packs."
        }
      }
      if (this.instantMode === "chosepack") {
        if (this.noTransformsAdded) {
          return "Select a Toy to start building.";
        } else {
          return "Select a Toy to continue building.";
        }
      }
      if (this.noTransformsAdded && this.instantMode === "placing") {
          return "Place the Toy by tapping the grid.";
      }
      if (!this.noTransformsAdded && this.instantMode == "placing") {
        return "Place the Toy by tapping the grid.";
        //return "Add more by tapping."
      }
      if (!this.noTransformsAdded && this.instantMode === "choosepack") {
        return "Tap to select toys or choose a pack to add more."
      }
      return "";

    },
    ...mapState(['isAdvancedMode', 'renderTools', 'noTransformsAdded', 'templateMode', 'isAnimationEnabled'])

  },
  components:{
    EditRenderer,
    Resize,
    PencilBox,
    InlineRender,
    TransformDetails,
    ComponentDetails,
    EditToolbar,
    EditToolbarAnon,
    SaveSelection,
    PlusCircle,
    SelectIcon,
    TransformEditComponents,
    AddTransformWizardDialog,
    AddComponentWizardDialog,
    GetContainerBounds,
    Check,
    Close,
    Overlay,
    Pencil,
    Plus,
    Alert,
    MagnifyPlus,
    MagnifyMinus,
    ImageFilterCenterFocus,
    Minus,
    Rectangle,
    AddTransforms,
    LayersEditDialog,
    SettingsDialog,
    InstantAddPack,
    GridTransformOverlay,
    SimpleOrAdvancedAddTransforms,
    TransformInfo,
    ApolloQuery,
    AwesomeBar,
    SetDuration,
    TemplateCustomizer,
    ChooseTemplate,
    ExpandAllOutline,
    Delete,
    PbcConfirmation,
    Undo,
    Redo,
    ContentDuplicate,
    EditOverlay,
    CanvasSizer
  }
}
</script>
